(function () {
    // ページ内のすべての要素を取得
  const elements = document.querySelectorAll('.wp-block-spacer');

  // 各要素に対してループ処理を実行
  elements.forEach(element => {
    // 現在の高さを取得
    const height = element.style.height;
    if (height === '') {
      element.style.setProperty('height', '3rem');
    } else if (parseInt(height) <= 57) {
      element.style.setProperty('height', '3rem');
    } else if (parseInt(height) <= 114) {
      element.style.setProperty('height', '6rem');
    } else {
      element.style.setProperty('height', '9rem');
    }
  });
})();
